<template>
  <div class="pageContainer app-container">
    <el-row class="flexStart">
      <el-select v-model="searchForm.ktype" size="small" placeholder="请选择" style="width: 150px;">
        <el-option label="学生姓名" value="stu_name">学生姓名</el-option>
        <el-option label="学生编号" value="stu_code">学生编号</el-option>
      </el-select>
      <el-input v-model="searchForm.keyword" size="small" placeholder="请输入查询关键字"
                style="max-width: 200px;margin-right: 10px;" />

            <el-select v-model="searchForm.gender" size="small" placeholder="性别" style="width: 100px;margin-right: 10px;">
              <el-option label="男" :value="1"></el-option>
              <el-option label="女" :value="2"></el-option>
            </el-select>

      <el-cascader ref="firstCascader" :options="treeData" :props="treeProps1" size="small"
                   v-model="searchForm.dept_id" :show-all-levels="true" @change="handleCascaderChange" placeholder="班级"
                   style="min-width: 300px;margin-right: 10px;" filterable clearable></el-cascader>


      <el-button size="small" icon="el-icon-search" @click="onSearch" plain type="primary">查询</el-button>
      <el-button size="small" icon="el-icon-refresh" @click="onReset" type="warning">重置</el-button>
    </el-row>



    <el-row type="flex" :gutter="14" style="margin-top: 20px">
      <el-col :span="16" class="tabContainer">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>请选择学生</span>
            <div style="float: right; color: #1370FB; font-size: 12px;">请选中学生后，再选择右侧宿舍</div>
          </div>
          <div>
            <Table :tableData="tableData" :page="page" @handleSelectionChange="handleSelectionChange"></Table>
          </div>
        </el-card>
      </el-col>
      <el-col :span="1">
        <div style="text-align: center; padding-top: 200px; color: #1370FB; font-size: 30px;">
          <i class="el-icon-sort" style="display: inline-block;transform: rotateZ(90deg);"></i>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>请选择宿舍</span>
              <el-button style="float: right;" type="primary" size="mini" icon="el-icon-s-claim"
                         @click="divideClass">确认</el-button>
            </div>
            <div>
              <el-tree ref="tree" node-key="id" :data="dormList" :props="treeProps" size="mini"
                       :default-expand-all="true" :expand-on-click-node="false" highlight-current>
                <div class="custom-tree-node" slot-scope="{ node, data }">
                  <el-radio v-if="data.node_type=='class'" v-model="classId" :label="data.id"
                            @change="changeRadioClass">
										<span>{{ node.label }}
											<strong style="color: #1370FB;">
												({{data.stu_count}})
											</strong>
											<i class="el-icon-user" @click="getClassStuList(data)" title="查看宿舍学生"
                         style="margin-left: 10px; font-weight: bold; color: #1370FB;"></i>
										</span>
                  </el-radio>
                  <div v-if="data.node_type!='class'">
                    <span>{{ node.label }}</span>
                  </div>

                </div>
              </el-tree>
            </div>
          </el-card>




        </div>
      </el-col>

    </el-row>


    <el-dialog :title="className" width="800px" :visible.sync="visible" :close-on-click-modal="false">

      <div style="position: absolute; top: 20px; right: 80px;">
        <el-button size="mini" el-icon="el-icon-remove" type="warning" @click="cancelDivide">取消分宿舍</el-button>
      </div>

      <Table :tableData="classStudents" :page="page" @handleSelectionChange="handleSelectionChange2"></Table>
    </el-dialog>
  </div>
</template>
<script>
import api from '@/api/api';
import Table from './components/TableDorm'

export default {
  name: 'StuClass',
  components: {
    Table
  },
  data() {
    return {
      visible: false,
      searchForm: {
        ktype: 'stu_name'
      }, //查询
      //tree
      treeData: [],
      treeProps: {
        children: 'children',
        label: 'title'
      },
      treeProps1: {
        children: 'children',
        label: 'title',
        value: 'id',
        emitPath: false,
      },
      //table
      tabMapOptions: [{
        label: '学生列表',
        key: 'CN'
      }, ],
      activeName: 'CN',

      tableData: [],
      page: {
        pageIndex: 1,
        pageSize: 100,
        total: 0
      },
      multipleSelection: [],
      multipleSelection2: [],
      deptId: null,
      editOptions: {},
      teacherId: null,
      classId: '',
      className: "",
      classStudents: [],
      dormList:[],
    }
  },
  watch: {
    activeName(val) {
      this.$router.push(`${this.$route.path}?tab=${val}`)
    }
  },
  created() {
    // init the default selected tab
    const tab = this.$route.query.tab
    if (tab) {
      this.activeName = tab
    }
  },
  mounted() {
    this.getList();
    this.getOrgList();
    this.getDormList()
  },
  methods: {
    getList() {
      this.tableData = [{
        class_name: '计算机1班',
        gender:1,
        graduate_sch_city: "江苏省,南京市,玄武区",
        major_name: "计算机网络技术",
        phone: "18100000000",
        stu_code: "20210000",
        stu_name: "李雷",
        username: "刘主任",
        yuanxi_name: "计算机管理系",
      }]
      this.page.total = 1
      return
      let params = Object.assign({
        page: this.page.pageIndex,
        pagesize: this.page.pageSize,
        stu_type: "all",
        status: 3
      }, this.searchForm)
      if (this.searchForm.dept_id) {
        let val = this.searchForm.dept_id
        let type = this.$refs['firstCascader'].panel.getNodeByValue(val).data.node_type
        if (type == "dept") {
          params.xibu = this.$refs['firstCascader'].panel.getNodeByValue(val).label
        } else {
          params.zhuanye = this.$refs['firstCascader'].panel.getNodeByValue(val).label
        }

      }
      params.ktype = this.searchForm.ktype;
      params.keyword = this.searchForm.keyword;
      if (this.searchForm.ktype == 'stu_name') {
        params.stu_name = this.searchForm.keyword
      }
      if (this.searchForm.ktype == 'archive') {
        params.archive = this.searchForm.keyword
      }
      if (this.searchForm.ktype == 'area_name') {
        params.area_name = this.searchForm.keyword
      }

      if (this.searchForm.ktype == 'title') {
        params.title = this.searchForm.keyword
      }

      this.$http.post(api.stuList, params).then(res => {
        for (let item of res.data.data) {
          let city = item.graduate_sch_city.split(",")
          if (city.length >= 3) {
            item.city = city[1]
          }
        }
        this.tableData = res.data.data
        this.page.total = res.data.page.count
      })
    },

    getOrgList() {
      let _this = this
      this.$http.post("/api/sch_major_list_and_num").then(res => {
        if (res&&res.data && res.data.length > 0) {
          _this.deleteEmptyGroup(res.data).then(result => {
            this.treeData = result
          })
        }
      })
    },
    getDormList(){
      this.dormList = [
        {
          id:1,
          title: "宿舍楼A",
          children:[
            {id:2,title: "101",node_type: "class",stu_count: 0},
            {id:3,title: "102",node_type: "class",stu_count: 1},
          ]
        },
        {
          id:4,
          title: "宿舍楼B",
          children:[
            {
              id:5,title: "101",node_type: "class",stu_count: 0}
          ]
        },
       {
         id:6,
             title: "宿舍楼C",
           children:[
         {
           id:7,title: "101",node_type: "class",stu_count: 0}
       ]
       },
        {
          id:8,
          title: "宿舍楼D",
          children:[
            {id:9,title: "101",node_type: "class",stu_count: 0},
            {id:10,title: "102",node_type: "class",stu_count: 1},
          ]
        },
      ]
    },
    // 处理没有children的分组
    deleteEmptyGroup(treeData) {
      return new Promise(resolve => {
        function traversal(data) {
          data.map(item => {
            for (let info in item) {
              if (item['children']) {
                if (item['children'].length > 0) {
                  traversal(item['children'])
                }
                if (item['children'].length == 0) {
                  delete item['children']
                }
              }
            }
          })
        }

        traversal(treeData)
        resolve(treeData)
      })
    },

    getClassStuList(cls) {
      if(cls&&cls.id){
        this.classId = cls.id
        this.className = cls.title
      }
      this.classStudents =  [{
        class_name: '计算机1班',
        gender:1,
        graduate_sch_city: "江苏省,南京市,玄武区",
        major_name: "计算机网络技术",
        phone: "18100000000",
        stu_code: "20210000",
        stu_name: "李雷",
        username: "刘主任",
        yuanxi_name: "计算机管理系",
      }]
      this.visible = true
      return
      this.$http.post("/api/get_class_students", {
        class_id: this.classId
      }).then(res => {
        this.classStudents = res.data
        this.visible = true

      })
    },
    changeRadioClass(e, b) {

      this.classId = e

      //查找班级名称

      for (let yx of this.treeData) {
        if (yx.children) {
          for (let major of yx.children) {
            if (major.children) {
              for (let cls of major.children) {
                if (cls.id == this.classId) {
                  this.className = cls.title;
                  break
                }
              }
            }
          }
        }

      }

    },
    handlePageChange(e) {
      this.page.pageIndex = e
      this.getList()
    },
    handleSelectionChange(val) {
      let _this = this;
      _this.multipleSelection = val;
    },
    handleSelectionChange2(val) {
      let _this = this;
      _this.multipleSelection2 = val;
    },
    divideClass() {
      let _this = this
      console.log(_this.multipleSelection)
      if (_this.multipleSelection && _this.multipleSelection.length > 0) {
        if (_this.classId) {
          this.$confirm('是否确定?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            return
            _this.$http.post(api.divideClass, {
              stu_id: _this.multipleSelection.map(e => {
                return e.id
              }).join(','),
              class_id: _this.classId
            }).then(res => {
              if (res.data.code == 500) {
                _this.$message.error('失败，请稍后再试!');
              } else {
                _this.$message.success('成功!');
                this.getList();
                this.getOrgList()

              }
            })
          })
        } else {
          _this.$message.warning('请选择宿舍！')
        }
      } else {
        _this.$message.warning('请选择学生！')
      }
    },
    cancelDivide() {
      let _this = this
      if (_this.multipleSelection2 && _this.multipleSelection2.length > 0) {
        this.$confirm('是否确定取消?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          return
          _this.$http.post("/api/t_sch_class_stu_delete", {
            stu_id: _this.multipleSelection2.map(e => {
              return e.id
            }).join(','),
          }).then(res => {
            if (res.data.code == 500) {
              _this.$message.error('取消失败，请稍后再试!');
            } else {
              _this.$message.success('取消成功!');
              this.getList();
              this.getClassStuList();
              this.getOrgList()
            }
          })
        })
      } else {
        _this.$message.warning('请选择学生！')
      }
    },
    onSearch() {
      this.tableData = [];
      this.page.pageIndex = 1;
      this.getList();
    },
    onReset() {
      this.searchForm = {
        ktype: 'stu_name'
      };
      this.tableData = [];
      this.page.pageIndex = 1;
      this.getList();
    },
    //分组
    groupBy(array, f) {
      let groups = {};
      array.forEach(function(o) {
        let group = JSON.stringify(f(o));
        groups[group] = groups[group] || [];
        groups[group].push(o);
      });
      return Object.keys(groups).map(function(group) {
        return groups[group];
      });
    },
    handleCascaderChange(e, opt) {
      console.log(e, this.$refs['firstCascader'].panel.getNodeByValue(e))
    },
  }
}
</script>

<style scoped lang="less" type="text/less">
.custom-tree-node{ font-size: 14px; }
</style>
